require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-meet-the-architect-raymond-mah.json") })
        }
      }, "path---news-meet-the-architect-raymond-mah");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-meet-the-architect-raymond-mah!./.cache/json/news-meet-the-architect-raymond-mah.json
// module id = 828
// module chunks = 231608221292675